/* ==========================================================================
   Custom Header — scroll-aware sticky + mobile drawer
   ========================================================================== */
(function () {
    const header = document.querySelector('.custom-header');
    if (!header) return;

    /* ---------------------------------------------------------------------
       Scroll-aware sticky header
       --------------------------------------------------------------------- */
    const DELTA = 6;
    let lastScrollY = window.scrollY;
    let ticking = false;
    let headerHeight = header.offsetHeight;

    window.addEventListener('resize', () => {
        headerHeight = header.offsetHeight;
    }, { passive: true });

    function updateScroll() {
        const y = window.scrollY;
        const diff = y - lastScrollY;

        if (Math.abs(diff) < DELTA) {
            ticking = false;
            return;
        }

        const scrollingDown = diff > 0;
        const pastHeader = y > headerHeight;

        if (pastHeader && !scrollingDown) {
            document.body.classList.add('custom-header-revealed');
        } else {
            document.body.classList.remove('custom-header-revealed');
        }

        document.body.classList.toggle('is-scrolled', y > 0);

        lastScrollY = y;
        ticking = false;
    }

    window.addEventListener('scroll', () => {
        if (!ticking) {
            requestAnimationFrame(updateScroll);
            ticking = true;
        }
    }, { passive: true });


    /* ---------------------------------------------------------------------
       Mobile drawer (hamburger menu)
       --------------------------------------------------------------------- */
    const burger     = header.querySelector('.custom-header__burger');
    const closeBtn   = header.querySelector('.custom-header__drawer-close');
    const backdrop   = header.querySelector('.custom-header__backdrop');
    const subToggles = header.querySelectorAll('.custom-header__sub-toggle');

    function openDrawer() {
        document.body.classList.add('custom-header-drawer-open');
        if (burger) burger.setAttribute('aria-expanded', 'true');
        // Lock body scroll while drawer is open
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
        document.body.classList.remove('custom-header-drawer-open');
        if (burger) burger.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
        // Collapse any open submenus so the drawer is fresh on next open
        subToggles.forEach(toggle => {
            toggle.setAttribute('aria-expanded', 'false');
            const item = toggle.closest('.custom-header__item--dropdown');
            if (item) item.classList.remove('is-open');
        });
    }

    if (burger) {
        burger.addEventListener('click', () => {
            const isOpen = document.body.classList.contains('custom-header-drawer-open');
            isOpen ? closeDrawer() : openDrawer();
        });
    }

    if (closeBtn) {
        closeBtn.addEventListener('click', closeDrawer);
    }

    if (backdrop) {
        backdrop.addEventListener('click', closeDrawer);
    }

    // Esc closes the drawer
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && document.body.classList.contains('custom-header-drawer-open')) {
            closeDrawer();
        }
    });

    // Auto-close if viewport grows past mobile breakpoint while drawer is open
    const mql = window.matchMedia('(min-width: 940px)');
    mql.addEventListener('change', (e) => {
        if (e.matches) closeDrawer();
    });

    /* ---------------------------------------------------------------------
       Submenu accordions (mobile only — chevron toggles its sibling list)
       --------------------------------------------------------------------- */
    subToggles.forEach(toggle => {
        toggle.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const item = toggle.closest('.custom-header__item--dropdown');
            if (!item) return;
            const isOpen = item.classList.toggle('is-open');
            toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
    });
})();